import React, { RefObject, SyntheticEvent } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { bindActionCreators } from "redux";
import { EditorMode, FeatureCategory, FieldFormat, FieldType, IAdHocProject, IAppSettings, IApplicationState, IAsset, IAssetMetadata, IClearLabelDataCommand, IHatchetAiCompanyProjectOcr, ILabel, IProject, IProjectLabel, IRegion, ISize, ITableConfigItem, ITableRegion, ITableTag, ITag, TableVisualizationHint, TagInputMode } from "../../../../models/applicationState";
import IAdHocOcrActions, * as adHocActions from "../../../../redux/actions/adHocOcrActions";
import IAdHocOcrV2Actions, * as adHocV2Actions from "../../../../redux/actions/adHocOcrV2Actions";
import SplitPane from "react-split-pane";
import Canvas from "./canvas";
import { TagInput } from "../../common/tagInput/tagInput";
import { OcrStatus } from "../../../../services/ocrService";
import { AssetPreview } from "../../common/assetPreview/assetPreview";
import IProjectActions from "../../../../redux/actions/projectActions";
import * as projectActions from "../../../../redux/actions/projectActions";
import _ from "lodash";
import "../editorPage/editorPage.scss";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import { constants } from "../../../../common/constants";
import CanvasHelpers from "../editorPage/canvasHelpers";
import Confirm from "../../common/confirm/confirm";
import clone from "rfdc";
import { getCookieEmail, parseEndpointByType } from "../../common/jsonSchemaFormHelper";
import axios from "axios";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import {
    getPrimaryBlueTheme,
    getPrimaryRedTheme,
} from "../../../../common/themes";
import { AssetService } from "../../../../services/assetService";
import EditLabelDialog from "../../common/editLabelDialog/editLabelDialog";
import { toast } from "react-toastify";
import { TableView } from "./tableView";
import SearchDialog from "../../common/searchDialog/searchDialog";
import { Label, Spinner, SpinnerSize } from "@fluentui/react";

interface IIntegrationV2PageProps extends RouteComponentProps, React.Props<AdHocOcrV2Page> {
    adHocOcr: IAdHocProject;
    adHocActions: IAdHocOcrActions;
    adHocV2Actions: IAdHocOcrV2Actions;
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
}

interface IIntegrationV2PageState {
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    editorMode: EditorMode;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    isRunningOCRs?: boolean;
    tagInputMode: TagInputMode;
    highlightedTableCellRegions: ITableRegion[];
    selectedTableTagToLabel: ITableTag;
    isValid: boolean;
    assets: IAsset[];
    thumbnailSize: ISize;
    sidePanelSize: number;
    selectedRegions?: IRegion[];
    pageNumber: number;
    selectedTableTagBody: ITableRegion[][][];
    rightSplitPaneWidth?: number;
    reconfigureTableConfirm?: boolean;
    projectLabels: IProjectLabel[];
    showEditDialog?: boolean;
    labelToEdit?: ILabel;
    isProcessingLabel?:boolean;
    runGenerateModel:boolean;
    tableToViewId: string;
    tableToView: null,
    showSearch?: boolean;
    isPageLoading: boolean;
}

function mapStateToProps(state: IApplicationState) {
    return {
        adHocOcr: state.adHocOcrV2,
        appSettings: state.appSettings
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        adHocActions: bindActionCreators(adHocActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),        
        adHocV2Actions: bindActionCreators(adHocV2Actions, dispatch)
    }
}

@connect(mapStateToProps, mapDispatchToProps)
export default class AdHocOcrV2Page extends React.Component<IIntegrationV2PageProps, IIntegrationV2PageState> {
    requestId: string;

    private canvas: RefObject<Canvas> = React.createRef();
    private tagInputRef: RefObject<TagInput>;
    public initialRightSplitPaneWidth: number;
    private renameCanceled: () => void;
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteTagsConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();
    private replaceConfirmRef = React.createRef<Confirm>();
    private reconfigTableConfirm: React.RefObject<Confirm> = React.createRef();
    private confirmResetTagConfirm = React.createRef<Confirm>();
    private editLabelDialogRef: React.RefObject<EditLabelDialog> =
        React.createRef();
    private searchDialogRef: React.RefObject<SearchDialog> = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            editorMode: EditorMode.Select,
            lockedTags: [],
            hoveredLabel: null,
            tagInputMode: TagInputMode.Basic,
            highlightedTableCellRegions: null,
            selectedTableTagToLabel: null,
            isValid: true, 
            assets: [],
            thumbnailSize: { width: 175, height: 155 },
            sidePanelSize: 248,
            pageNumber: 1,
            selectedTableTagBody: [[]],
            projectLabels: [],
            isProcessingLabel: false,
            runGenerateModel: false,
            tableToViewId: null,
            tableToView: null,
            isPageLoading: true
        }
        this.tagInputRef = React.createRef();

        this.onTagDeleteChecked = this.onTagDeleteChecked.bind(this);
        this.downloadToExcelClick = this.downloadToExcelClick.bind(this);       
        this.processingLabel = this.processingLabel.bind(this);
    }
    public async componentDidMount() {
        let url = new URL(window.location.href);
        this.requestId = url.searchParams.get("requestId");
        if (this.requestId) {
            try {
                this.props.applicationActions.setWidgetMode();
                await this.props.adHocV2Actions.loadAdHocOcrProject(this.requestId);
                await this.loadProjectAssets();                        
            }
            catch(e) {
                toast.error(e);
            }
            document.title = "HatchetAI";
        }
    }

    private handleTableViewClose = () => {
        this.closeTableView("rest");
    };

    // private getOcrForPage = async (page: number): Promise<IHatchetAiCompanyProjectOcr> => {
    //     const ocr = await this.props.adHocActions.getOcrProjectForPage(this.requestId, page, this.state.selectedAsset.asset.path, this.state.selectedAsset.asset.name);
    //     return ocr;
    // }

    // private updateDocumentOcr = async (assetName: string, ocr: string) => {
    //     await this.props.adHocActions.updateDocumentOcr(this.props.adHocOcr.project.id, this.props.adHocOcr.project.name, assetName, ocr);
    // }

    render() {
        const { selectedAsset } = this.state;
        
        const isBasicInputMode = this.state.tagInputMode === TagInputMode.Basic;
        this.initialRightSplitPaneWidth = isBasicInputMode ? 290 : 520;

        const labels =
            (selectedAsset &&
                selectedAsset.labelData &&
                selectedAsset.labelData.labels) ||
            [];
        const tableLabels =
            (selectedAsset &&
                selectedAsset.labelData &&
                selectedAsset.labelData.tableLabels) ||
            [];

        return (
            <React.Fragment>
                <div className="editor-page skipToMainContent" id="pageEditor">        
                    { this.state.isPageLoading && 
                        <div className="project-loading" 
                            style={{
                                zIndex: 1,
                                position: "fixed", // Ensure it overlays the entire screen
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
                                display: "flex",
                                justifyContent: "center", // Center horizontally
                                alignItems: "center", // Center vertically
                            }}
                        >
                            <div className="project-loading-spinner" 
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                <Spinner
                                    size={SpinnerSize.large}
                                    label="Loading Project, Please wait..."
                                    ariaLive="assertive"
                                    labelPosition="bottom" // Move label below the spinner
                                    styles={{
                                        root: {
                                            color: "#0078d4", // Blue spinner color
                                        },
                                        label: {
                                            fontSize: "16px", // Slightly larger font for better readability
                                            color: "#333", // Dark gray text color
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    }
                    <div className="editor-page-content">
                        {this.state.tableToView !== null && (
                            <TableView
                                handleTableViewClose={this.handleTableViewClose}
                                tableToView={this.state.tableToView}
                            />
                        )}
                        <SplitPane
                            split="vertical"
                            primary="second"
                            maxSize={isBasicInputMode ? 400 : 700}
                            minSize={this.initialRightSplitPaneWidth}
                            className={"right-vertical_splitPane"}
                            pane1Style={{ height: "100%" }}
                            pane2Style={{ height: "auto" }}
                            resizerStyle={{
                                width: "5px",
                                margin: "0px",
                                border: "2px",
                            }}
                            onChange={(width) => {
                                if (!isBasicInputMode) {
                                    //this.setState(
                                    //    {
                                    //        rightSplitPaneWidth: width > 700 ? 700 : width
                                    //    },
                                    //    () => {
                                    //        this.resizeCanvas();
                                    //    }
                                    //);
                                    this.setState(prevState => {
                                        return {
                                            ...prevState,
                                            rightSplitPaneWidth: width > 700 ? 700 : width
                                        }
                                    }, () => {
                                        this.resizeCanvas();
                                    })
                                    this.resizeCanvas();
                                }
                            }}
                        >
                            <div className="editor-page-content-main">
                                <div className="editor-page-content-main-body">
                                    { this.props && this.props.adHocOcr && this.props.adHocOcr.project && 
                                        this.state.selectedAsset && 
                                        <Canvas 
                                            ref={this.canvas}
                                            selectedAsset={
                                                this.state.selectedAsset
                                            }
                                            onAssetMetadataChanged={
                                                this.onAssetMetadataChanged
                                            }
                                            onCanvasRendered={
                                                this.onCanvasRendered
                                            }
                                            onSelectedRegionsChanged={
                                                this.onSelectedRegionsChanged
                                            }
                                            onRegionDoubleClick={
                                                this.onRegionDoubleClick
                                            }
                                            onRunningOCRStatusChanged={
                                                this.onCanvasRunningOCRStatusChanged
                                            }
                                            onRunningAutoLabelingStatusChanged={
                                                this.onCanvasRunningAutoLabelingStatusChanged
                                            }
                                            onTagChanged={this.onTagChanged}
                                            onAssetDeleted={
                                                this.confirmDocumentDeleted
                                            }
                                            editorMode={this.state.editorMode}
                                            project={this.props.adHocOcr.project}
                                            lockedTags={this.state.lockedTags}
                                            hoveredLabel={
                                                this.state.hoveredLabel
                                            }
                                            setTableToView={this.setTableToView}
                                            closeTableView={this.closeTableView}
                                            runOcrForAllDocs={
                                                this.loadOcrForNotVisited
                                            }
                                            isRunningOCRs={
                                                this.state.isRunningOCRs
                                            }
                                            onPageLoaded={this.onPageLoaded}
                                            runAutoLabelingOnNextBatch={
                                                this.runAutoLabelingOnNextBatch
                                            }
                                            appSettings={this.props.appSettings}
                                            handleLabelTable={
                                                this.handleLabelTable
                                            }
                                            highlightedTableCell={
                                                this.state
                                                    .highlightedTableCellRegions
                                            }
                                            showSearch={true}
                                            handlerSearch={this.onHandleSearch}
                                            showUploadGeneratedTagsToApi={this.showUploadGeneratedTagsToApi}     
                                            adHocOcr={this.props.adHocOcr}     
                                            // getOcrForPage={this.getOcrForPage}      
                                            //TODO: THIS IS NEEDED
                                            //updateAdHocOcrProjectOcr={this.props.adHocActions.updateAdHocOcrProjectOcr}       
                                            widgetMode={this.props.appSettings.widgetMode}                  
                                        >
                                            <AssetPreview
                                                controlsEnabled={
                                                    this.state.isValid
                                                }
                                                onBeforeAssetChanged={
                                                    this.onBeforeAssetSelected
                                                }
                                                asset={
                                                    this.state.selectedAsset
                                                        .asset
                                                }
                                            />
                                        </Canvas>
                                    }                                    
                                </div>
                            </div>

                            <div className="editor-page-right-sidebar">
                                {this.state.selectedAsset &&
                                    (<TagInput
                                        selectAllForDelete={false}
                                        project={this.props.adHocOcr.project}
                                        tagsLoaded={true}
                                        tags={this.props.adHocOcr.project.tags}
                                        lockedTags={this.state.lockedTags}
                                        selectedRegions={
                                            this.state.selectedRegions
                                        }
                                        labels={labels}
                                        encoded={
                                            selectedAsset?.labelData
                                                ?.$schema ===
                                            constants.labelsSchema
                                        }
                                        tableLabels={tableLabels}
                                        pageNumber={this.state.pageNumber}
                                        onChange={this.onTagsChanged}
                                        onLockedTagsChange={
                                            this.onLockedTagsChanged
                                        }
                                        onTagClick={this.onTagClicked}
                                        onCtrlTagClick={
                                            this.onCtrlTagClicked
                                        }
                                        onTagRename={this.confirmTagRename}
                                        onTagDeleted={
                                            this.confirmTagDeleted
                                        }
                                        onDeleteSeletedTags={
                                            this.confirmTagsDeleted
                                        }
                                        onDeleteCheckedChanged={
                                            this.onTagDeleteChecked
                                        }
                                        onLabelEnter={this.onLabelEnter}                                        
                                        onLabelLeave={this.onLabelLeave}
                                        onTagChanged={this.onTagChanged}
                                        ref={this.tagInputRef}
                                        setTagInputMode={
                                            this.setTagInputMode
                                        }
                                        tagInputMode={
                                            this.state.tagInputMode
                                        }
                                        handleLabelTable={
                                            this.handleLabelTable
                                        }
                                        selectedTableTagToLabel={
                                            this.state
                                                .selectedTableTagToLabel
                                        }
                                        handleTableCellClick={
                                            this.handleTableCellClick
                                        }
                                        handleTableCellMouseEnter={
                                            this.handleTableCellMouseEnter
                                        }
                                        handleTableCellMouseLeave={
                                            this.handleTableCellMouseLeave
                                        }
                                        selectedTableTagBody={
                                            this.state.selectedTableTagBody
                                        }
                                        splitPaneWidth={
                                            this.state.rightSplitPaneWidth
                                        }
                                        reconfigureTableConfirm={
                                            this.reconfigureTableConfirm
                                        }
                                        addRowToDynamicTable={
                                            this.addRowToDynamicTable
                                        }
                                        onTagDoubleClick={
                                            this.onLabelDoubleClicked
                                        }
                                        handelDownloadClick={(withTables: boolean) =>
                                            this.downloadToExcelClick(withTables)
                                        }
                                        onLabelEdit={this.onLabelEdit}
                                        onResetClick={this.onResetClick}
                                        confirmResetTag={this.confirmResetTag}
                                        toggleTagSpinner={this.toggleTagSpinner}
                                        widgetMode={this.props.appSettings.widgetMode}
                                        processingLabel={this.processingLabel} 
                                        onLabelClick={this.onLabelClick}
                                    />)
                                }
                            </div>
                        </SplitPane>

                        <Confirm
                            ref={this.confirmResetTagConfirm}
                            title="Reset"
                            // tslint:disable-next-line:max-line-length
                            message={() =>
                                "Are you sure you want to reset the tag value?"
                            }
                            confirmButtonTheme={getPrimaryRedTheme()}
                            onConfirm={(label) => this.confirmResetTag(label)}
                            onCancel={() => this.onCancelResetTag()}
                        />

                        <SearchDialog
                            show={this.state.showSearch}
                            onClose={this.closeSearchDialog}
                            onSearchClick={this.onSearchButtonClick}
                            clearSearch={this.clearSearchButtonClick}
                            ref={this.searchDialogRef}
                            canvas={this.canvas}
                            fileName={
                                this.state.selectedAsset
                                    ? this.state.selectedAsset.asset.name
                                    : null
                            }
                            currentPage={
                                this.canvas.current
                                    ? this.canvas.current.currentPage()
                                    : 1
                            }
                            container={this.props.adHocOcr ? this.props.adHocOcr : null}
                        />

                        <EditLabelDialog
                            show={this.state.showEditDialog}
                            onClose={this.closeEditLabelDialog}
                            onSaveEditLabelClick={this.onSaveEditLabelClick}
                            ref={this.editLabelDialogRef}
                            container={this.props.adHocOcr?.project ? this.props.adHocOcr?.project : null}
                            label={this.state.labelToEdit}
                        />
                    </div>
                </div>                
            </React.Fragment>
        );
    }

    private toggleTagSpinner = (show: boolean) => {
        this.setState(prevState => {
            return {
                ...prevState,
                processingUploadedTags: show
            }
        });
    };

    private processingLabel = (processing: boolean) => {
        this.setState(prevState => {
            return {
                ...prevState,
                isProcessingLabel: processing
            }
        });
    }
    
    // private isBusy = (): boolean => {
    //     return (
    //         this.state.isRunningOCRs ||
    //         this.state.isCanvasRunningOCR ||
    //         this.state.isCanvasRunningAutoLabeling
    //     );
    // };

    private onCancelResetTag() {
        // this.setState({ showSearch: true });
    }


    private async confirmResetTag(label: ILabel) {
        const { selectedAsset } = this.state;
        if (selectedAsset && selectedAsset.labelData && selectedAsset.labelData.labels && selectedAsset.labelData.labels.length > 0) {
            selectedAsset.labelData.labels = selectedAsset.labelData.labels.filter((l) => l.label !== label.label);
        }        
        this.setState((prevState) => {
            return {
                ...prevState,
                clearingLabel: true
            }
        });

        try {
            const assetService = new AssetService(this.props.adHocOcr.project);

            // let newMeta = await this.props.actions.saveAssetMetadataAdhoc(
            //     this.props.adHocOcr.project,
            //     selectedAsset
            // );

            let newMeta = await this.props.actions.saveAssetMetadataAdhocV2(
                this.props.adHocOcr.project,
                selectedAsset
            );

            //TODO: THIS IS NEEDED
            //await this.props.adHocActions.updateAdHocOcrProjectAssetLabel(this.props.adHocOcr.project.id, this.props.adHocOcr.project.name, selectedAsset.asset.name, JSON.stringify(selectedAsset.labelData), false, '', this.state.runGenerateModel);

            await this.loadProjectAssets(true);
            await this.selectAsset(this.state.selectedAsset.asset, true);
            this.canvas.current.fullRedrawFeatures();

        } catch (error) {
            console.log(error);
        } finally {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    clearingLabel: false
                }
            });
        }
    }

    private onLabelEdit = (label: ILabel) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                showEditDialog: true,
                labelToEdit: label
            }
        });
    };

    private closeEditLabelDialog = () => {        
        this.setState((prevState) => {
            return {
                ...prevState,
                showEditDialog: false,
                labelToEdit: null
            }
        });
    };

    private onSaveEditLabelClick = async (
        event: SyntheticEvent,
        label: ILabel
    ) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                savingLabel: true
            }
        });

        this.canvas.current.applyTag(label.label, null, null, label);
        this.canvas.current.disableDrawRegionMode();

        setTimeout(() => {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    savingLabel: false
                }
            });
        }, 1000);
    };

    private onResetClick = (label: ILabel) => {
        this.confirmResetTagConfirm.current.open(label);
    };

    private downloadToExcelClick = async (withTables: boolean) => {
        // if (this.isBusy()) {
        //     return;
        // }

        const assets = this.props.adHocOcr.project.assets;

        let arrays = Array<string>();
        let keys = Object.keys(assets);

        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            arrays.push(assets[key].name);
        }

        this.setState((prevState) => {
            return {
                ...prevState,
                downloading: true
            }
        });

        try {
            const response = await axios.post(
                parseEndpointByType("HachetDownloadExcel"),
                {
                    FileNames: arrays,
                    Name: this.props.adHocOcr.project.name,
                    Email: getCookieEmail(),
                    WithTables: withTables
                },
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        withCredentials: "true",
                    },
                    responseType: "blob",
                }
            );

            if (response) {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `"hachetai-result-${Math.round(+new Date() / 1000)}.xlsx`
                ); //or any other extension
                document.body.appendChild(link);
                link.click();

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        downloading: false
                    }
                });
            }
        } catch (error) {
            console.log(error.response);
        }
    };

    private onLabelDoubleClicked = (label: ILabel) => {
        this.canvas.current.focusOnLabel(label);
    };

    private addRowToDynamicTable = () => {
        const selectedTableTagBody = clone()(this.state.selectedTableTagBody);
        selectedTableTagBody.push(
            Array(this.state.selectedTableTagToLabel.definition.fields.length)
        );
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTableTagBody
            }
        });
    };

    private handleTableCellMouseLeave = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                highlightedTableCellRegions: null
            }
        });
    };

    private handleTableCellMouseEnter = (regions) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                highlightedTableCellRegions: regions
            }
        });
    };

    private onTableTagClicked = (
        tag: ITag,
        rowIndex: number,
        columnIndex: number
    ): void => {
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTag: tag.name,
                lockedTags: []
            }
        },
            () => {
                this.canvas.current.applyTag(tag.name, rowIndex, columnIndex);
                this.canvas.current.disableDrawRegionMode();
            });
    };

    private handleTableCellClick = (rowIndex: number, columnIndex: number) => {
        if (
            !this.state.selectedRegions ||
            this.state.selectedRegions.length === 0
        ) {
            return;
        }

        if (
            this.state?.selectedTableTagBody?.[rowIndex]?.[columnIndex]
                ?.length > 0
        ) {
            const selectionRegionCatagory =
                this.state.selectedRegions[0].category;
            const cellCatagory =
                this.state.selectedTableTagBody[rowIndex][columnIndex][0]
                    .category;
            if (
                selectionRegionCatagory !== cellCatagory &&
                (selectionRegionCatagory === FeatureCategory.DrawnRegion ||
                    cellCatagory === FeatureCategory.DrawnRegion)
            ) {
                this.replaceConfirmRef.current.open(
                    this.state.selectedTableTagToLabel,
                    rowIndex,
                    columnIndex
                );
                return;
            }
        }

        this.onTableTagClicked(
            this.state.selectedTableTagToLabel,
            rowIndex,
            columnIndex
        );
    };

    private setTagInputMode = (
        tagInputMode: TagInputMode,
        selectedTableTagToLabel: ITableTag = this.state.selectedTableTagToLabel,
        selectedTableTagBody: ITableRegion[][][] = this.state.selectedTableTagBody
    ) => {
        // this.resizeCanvas();

        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTableTagBody,
                selectedTableTagToLabel,
                tagInputMode,
            }
        },
            () => {
                this.resizeCanvas();
            });
    };

    clearSearchButtonClick = async () => {
        if (this.canvas.current) await this.canvas.current.resetCurrentPage();
    };

    private onSearchButtonClick = async (
        event: SyntheticEvent,
        params: ILabel
    ) => {
        if (params) {
            await this.canvas.current.goToPage(params.value[0].page);

            setTimeout(() => {
                this.canvas.current.highlightFoundRegions(params);

                this.closeSearchDialog();
            }, 500);
        } else {
            await this.canvas.current.goToPage(1);
        }
    };

    private closeSearchDialog = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                showSearch: false
            }
        });
    };

    private onLabelLeave = (label: ILabel) => {
        this.setState({ hoveredLabel: null });
    };

    private onLabelEnter = (label: ILabel) => {
        this.setState({ hoveredLabel: label });
    };

    private onLabelClick = async (label: ILabel) => {
        //this.onSearchButtonClick(null, label);
        await this.canvas.current.goToPage(label.value[0].page);
        this.setState({ hoveredLabel: null }, () => {
            setTimeout(() => {
                this.setState({ hoveredLabel: label });        
            }, 500);
        });        
    };

    private confirmTagsDeleted = (tagLabelMap: Map<string, ILabel[]>): void => {
        this.deleteTagsConfirm.current.open(tagLabelMap);
    };
    
    private confirmTagDeleted = (
        tagName: string,
        tagType: FieldType,
        tagFormat: FieldFormat,
        labels?: ILabel[]
    ): void => {
        this.deleteTagConfirm.current.open(tagName, tagType, tagFormat, labels);
    };

    private confirmTagRename = (
        tag: ITag,
        newTag: ITag,
        cancelCallback: () => void
    ): void => {
        this.renameCanceled = cancelCallback;
        this.renameTagConfirm.current.open(tag, newTag);
    };

    private onCtrlTagClicked = (tag: ITag): void => {
        const locked = this.state.lockedTags;
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTag: tag.name,
                lockedTags: CanvasHelpers.toggleTag(locked, tag.name)
            }
        },
            () => {
                this.canvas.current.applyTag(tag.name);
                this.canvas.current.disableDrawRegionMode();
            });
    };

    private onTagClicked = (tag: ITag): void => {
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTag: tag.name,
                lockedTags: [],
                runGenerateModel: true
            }
        },
            () => {
                this.canvas.current.applyTag(tag.name);
                // this.canvas.current.disableDrawRegionMode();
            });
    };

    private onLockedTagsChanged = (lockedTags: string[]) => {
        this.setState(prevState => {
            return {
                ...prevState,
                lockedTags
            }
        });
    };

    private onTagsChanged = async (tags, tagChangedCallback?: any) => {
        const project = {
            ...this.props.adHocOcr.project,
            tags,
        };
        //TODO: Save Project
        //await this.props.actions.saveProject(project, true, false, this.savedToken);
        if (tagChangedCallback) {
            tagChangedCallback();
        }
    };

    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    };

    private onSideBarResize = (newWidth: number) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                thumbnailSize: {
                    width: newWidth,
                    height: newWidth / (4 / 3),
                }
            }
        });
        this.resizeCanvas();
    };

    private resizeCanvas = () => {
        if (this.canvas.current) {
            this.canvas.current.updateSize();
        }
    };

    private compareAssetLabelsWithProjectTags = (
        labels: ILabel[],
        tags: ITag[]
    ): boolean => {
        if (!labels || labels.length === 0) {
            return false;
        }
        const intersectionTags = _.intersectionWith(
            labels,
            tags,
            (l, t) => l.label === t.name
        );
        return intersectionTags?.length < labels.length;
    };

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (
        assetMetadata: IAssetMetadata
    ): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.
        assetMetadata = _.cloneDeep(assetMetadata);
        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        // Only update asset metadata if state changes or is different
        if (
            initialState !== asset.state ||
            this.state.selectedAsset !== assetMetadata
        ) {
            if (
                JSON.stringify(assetMetadata.labelData) !==
                JSON.stringify(this.state.selectedAsset.labelData)
            ) {
                await this.updatedAssetMetadata(assetMetadata);
            }

            assetMetadata.asset = asset;
            let newMeta = await this.props.actions.saveAssetMetadataAdhocV2(
                this.props.adHocOcr.project,
                assetMetadata
            );
            //TODO: THIS IS NEEDED
            //await this.props.adHocActions.updateAdHocOcrProjectAssetLabel(this.props.adHocOcr.project.id, this.props.adHocOcr.project.name, assetMetadata.asset.name, JSON.stringify(assetMetadata.labelData), false, '', this.state.runGenerateModel);

            // Get regions from label data since meta data will not have regions when loaded.
            newMeta.regions =
            this.canvas.current?.convertLabelDataToRegions(
                newMeta.labelData
            ) || [];
            this.setState(prevState => {
                return {
                    ...prevState,
                    selectedAsset: newMeta
                }
            });
            if (
                this.compareAssetLabelsWithProjectTags(
                    assetMetadata.labelData?.labels,
                    this.props.adHocOcr.project.tags
                )
            ) {
                // await this.props.actions.updateProjectTagsFromFiles(
                //     this.props.adHocOcr.project,
                //     assetMetadata.asset.name
                // );
            }
        }
    };

    private async updatedAssetMetadata(assetMetadata: IAssetMetadata) {
        const rowDocumentCountDifference = {};
        const updatedRowLabels = {};
        const currentRowLabels = {};
        const columnDocumentCountDifference = {};
        const updatedColumnLabels = {};
        const currentColumnLabels = {};
        assetMetadata?.labelData?.tableLabels?.forEach((table) => {
            updatedRowLabels[table.tableKey] = {};
            updatedColumnLabels[table.tableKey] = {};
            table.labels.forEach((label) => {
                updatedRowLabels[table.tableKey][label.rowKey] = true;
                updatedColumnLabels[table.tableKey][label.columnKey] = true;
            });
        });

        this.state.selectedAsset?.labelData?.tableLabels?.forEach((table) => {
            currentRowLabels[table.tableKey] = {};
            currentColumnLabels[table.tableKey] = {};
            table.labels.forEach((label) => {
                currentRowLabels[table.tableKey][label.rowKey] = true;
                currentColumnLabels[table.tableKey][label.columnKey] = true;
            });
        });

        Object.keys(currentColumnLabels).forEach((table) => {
            Object.keys(currentColumnLabels[table]).forEach((columnKey) => {
                if (!updatedColumnLabels?.[table]?.[columnKey]) {
                    if (!(table in columnDocumentCountDifference)) {
                        columnDocumentCountDifference[table] = {};
                    }
                    columnDocumentCountDifference[table][columnKey] = -1;
                }
            });
        });

        Object.keys(updatedColumnLabels).forEach((table) => {
            Object.keys(updatedColumnLabels[table]).forEach((columnKey) => {
                if (!currentColumnLabels?.[table]?.[columnKey]) {
                    if (!(table in columnDocumentCountDifference)) {
                        columnDocumentCountDifference[table] = {};
                    }
                    columnDocumentCountDifference[table][columnKey] = 1;
                }
            });
        });

        Object.keys(currentRowLabels).forEach((table) => {
            Object.keys(currentRowLabels[table]).forEach((rowKey) => {
                if (!updatedRowLabels?.[table]?.[rowKey]) {
                    if (!(table in rowDocumentCountDifference)) {
                        rowDocumentCountDifference[table] = {};
                    }
                    rowDocumentCountDifference[table][rowKey] = -1;
                }
            });
        });

        Object.keys(updatedRowLabels).forEach((table) => {
            Object.keys(updatedRowLabels[table]).forEach((rowKey) => {
                if (!currentRowLabels?.[table]?.[rowKey]) {
                    if (!(table in rowDocumentCountDifference)) {
                        rowDocumentCountDifference[table] = {};
                    }
                    rowDocumentCountDifference[table][rowKey] = 1;
                }
            });
        });

        const assetDocumentCountDifference = {};
        const updatedAssetLabels = {};
        const currentAssetLabels = {};
        assetMetadata.labelData?.labels?.forEach((label) => {
            updatedAssetLabels[label.label] = true;
        });
        this.state.selectedAsset.labelData?.labels?.forEach((label) => {
            currentAssetLabels[label.label] = true;
        });
        Object.keys(currentAssetLabels).forEach((label) => {
            if (!updatedAssetLabels[label]) {
                assetDocumentCountDifference[label] = -1;
            }
        });
        Object.keys(updatedAssetLabels).forEach((label) => {
            if (!currentAssetLabels[label]) {
                assetDocumentCountDifference[label] = 1;
            }
        });
    }

    /**
     * Raised when the asset binary has been painted onto the canvas tools rendering canvas
     */
    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
    };

    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
        if (this.state.isProcessingLabel) {
            return;
        }
        this.setState(prevState => {
            return {
                ...prevState,
                selectedRegions
            }
        });
    };

    private onRegionDoubleClick = (region: IRegion) => {
        if (region.tags?.length > 0 && this.tagInputRef.current) {
            this.tagInputRef.current.focusTag(region.tags[0]);
        }
    };

    private onCanvasRunningOCRStatusChanged = (ocrStatus: OcrStatus) => {
        
    };

    private onCanvasRunningAutoLabelingStatusChanged = (
        isCanvasRunningAutoLabeling: boolean
    ) => {
        //this.setState({ isCanvasRunningAutoLabeling });
    };

    private onTagChanged = async (oldTag: ITag, newTag: ITag) => {
        // const assetUpdates = await this.props.actions.updateProjectTag(
        //     this.props.project,
        //     oldTag,
        //     newTag
        // );
        // const selectedAsset = assetUpdates.find(
        //     (am) => am.asset.id === this.state.selectedAsset.asset.id
        // );

        // if (selectedAsset) {
        //     this.setState({
        //         selectedAsset,
        //     });
        // }
    };

    /**
     * Open Confirm dialog for document deletion
     */
    private confirmDocumentDeleted = (): void => {
        //this.deleteDocumentConfirm.current.open();
    };

    private setTableToView = async (tableToView, tableToViewId) => {
        if (this.state.tableToViewId) {
            this.canvas.current.setTableState(this.state.tableToViewId, "rest");
        }
        this.canvas.current.setTableState(tableToViewId, "selected");
        this.setState({
            tableToView,
            tableToViewId,
        });
    };

    private closeTableView = (state: string) => {
        if (this.state.tableToView) {
            this.canvas.current.setTableState(this.state.tableToViewId, state);
            this.setState({
                tableToView: null,
                tableToViewId: null,
            });
        }
    };

    public loadOcrForNotVisited = async (runForAll?: boolean) => {
        // if (this.isBusy()) {
        //     return;
        // }
        // const { project } = this.props;
        // const ocrService = new OCRService(project);
        // if (this.state.assets) {
        //     this.setState({ isRunningOCRs: true });
        //     try {
        //         this.isOCROrAutoLabelingBatchRunning = true;
        //         await throttle(
        //             constants.maxConcurrentServiceRequests,
        //             this.state.assets
        //                 .filter((asset) =>
        //                     runForAll
        //                         ? asset
        //                         : asset.state === AssetState.NotVisited
        //                 )
        //                 .map((asset) => asset.id),
        //             async (assetId) => {
        //                 // Get the latest version of asset.
        //                 const asset = this.state.assets.find(
        //                     (asset) => asset.id === assetId
        //                 );
        //                 if (
        //                     asset &&
        //                     (asset.state === AssetState.NotVisited || runForAll)
        //                 ) {
        //                     try {
        //                         this.updateAssetOCRAndAutoLabelingState({
        //                             id: asset.id,
        //                             isRunningOCR: true,
        //                         });
        //                         const ocrResult =
        //                             await ocrService.getRecognizedText(
        //                                 asset.path,
        //                                 asset.name,
        //                                 asset.mimeType,
        //                                 undefined,
        //                                 runForAll
        //                             );

        //                         if (ocrResult) {
        //                             this.updateAssetOCRAndAutoLabelingState({
        //                                 id: asset.id,
        //                                 isRunningOCR: false,
        //                             });
        //                             await this.props.actions.refreshAsset(
        //                                 this.props.project,
        //                                 asset.name
        //                             );
        //                         }
        //                     } catch (err) {
        //                         this.updateAssetOCRAndAutoLabelingState({
        //                             id: asset.id,
        //                             isRunningOCR: false,
        //                         });
        //                         this.setState({
        //                             isError: true,
        //                             errorTitle: err.title,
        //                             errorMessage: err.message,
        //                         });
        //                     }
        //                 }
        //             }
        //         );
        //     } finally {
        //         this.setState({ isRunningOCRs: false });
        //         this.isOCROrAutoLabelingBatchRunning = false;
        //     }
        // }
    };

    private reconfigureTableConfirm = (
        originalTagName: string,
        tagName: string,
        tagType: FieldType.Array | FieldType.Object,
        tagFormat: FieldFormat,
        visualizationHint: TableVisualizationHint,
        deletedColumns: ITableConfigItem[],
        deletedRows: ITableConfigItem[],
        newRows: ITableConfigItem[],
        newColumns: ITableConfigItem[]
    ) => {
        this.setState({ reconfigureTableConfirm: true });
        this.reconfigTableConfirm.current.open(
            originalTagName,
            tagName,
            tagType,
            tagFormat,
            visualizationHint,
            deletedColumns,
            deletedRows,
            newRows,
            newColumns
        );
    };

    private onTagDeleteChecked() {
        
    }

    private onPageLoaded = async (pageNumber: number) => {
        this.setState(prevState => {
            return {
                ...prevState,
                pageNumber,
                isPageLoading: false
            }
        });
    };

    private runAutoLabelingOnNextBatch = async (batchSize: number) => {
        
    };

    private handleLabelTable = (
        tagInputMode: TagInputMode = this.state.tagInputMode,
        selectedTableTagToLabel: ITableTag = this.state.selectedTableTagToLabel
    ) => {
        
    };

    private onHandleSearch = () => {
        // if (!this.canvas.current.areAllPagesOCR()) {
        //     this.confirmOCRSearchAll.current.open();
        // } else {
        // }
        this.setState((prevState) => {
            return {
                ...prevState,
                showSearch: true
            }
        });
    };

    private showUploadGeneratedTagsToApi() {
        this.setState((prevState) => {
            return {
                ...prevState,
                showUploadTagsModal: true,
                uploadTagsModalKey: new Date().getTime()
            }
        });
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    showInvalidRegionWarning: true
                }
            });
        }

        return this.state.isValid;
    };

    private selectAsset = async (
        asset: IAsset,
        force: boolean = false
    ): Promise<void> => {
        // Nothing to do if we are already on the same asset.
        if (
            !force &&
            this.state.selectedAsset &&
            this.state.selectedAsset.asset.id === asset.id
        ) {
            return;
        }

        if (!this.state.isValid) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    showInvalidRegionWarning: true
                }
            });
            return;
        }
        

        const self = this;

        this.setState(prevState => {
            return {
                ...prevState,
                processingSelectedAsset: true
            }
        }, async () => {
            
            const assetMetadata = await self.props.actions.loadAssetMetadataAdhocV2(
                self.props.adHocOcr.project,
                asset,
                self.props.adHocOcr.labels
            );

            // Get regions from label data since meta data will not have regions when loaded.
            assetMetadata.regions =
                this.canvas.current?.convertLabelDataToRegions(
                    assetMetadata.labelData
                ) || [];

            self.setState(prevState => {
                return {
                    ...prevState,
                    tableToView: null,
                    tableToViewId: null,
                    selectedAsset: assetMetadata,
                    processingSelectedAsset: false
                }
            }
                
            )
        })
    };

    private loadProjectAssets = async (
        force: boolean = false
    ): Promise<void> => {
        // if (this.loadingProjectAssets) {
        //     return;
        // }

        // this.loadingProjectAssets = true;
        const replacer = (key, value) => {
            if (key === "cachedImage") {
                return undefined;
            } else {
                return value;
            }
        };

        try {
            const keys = Object.keys(this.props.adHocOcr.project.assets);
            let assets = keys.map(key => this.props.adHocOcr.project.assets[key]);

            this.setState(
                {
                    assets: assets
                },
                async () => {
                    if (assets.length > 0) {
                        await this.selectAsset(assets[0]);
                    }                    
                }
            );
        } catch (error) {
            throw Error(error);
        }
        finally {
            //this.loadingProjectAssets = false;
        }
    };

    // private loadAutoLabelingOnCurrentDocument = async () => {
    //     try {
    //         //this.setAutoLabelingStatus(AutoLabelingStatus.running);
    //         const asset = this.state.assets[0];
    //         // const assetPath = asset.path;
    //         // const predictService = new PredictService(this.props.project);
    //         // const result = await predictService.getPrediction(assetPath);
    //         const autoLabel = this.props.adHocOcr.autoLabels.filter(r => r.assetName == asset.name);
    //         if (autoLabel) {
    //             const assetService = new AssetService(this.props.adHocOcr.project);
    //             const assetMetadata = assetService.getAssetPredictMetadata(
    //                 asset,
    //                 JSON.parse(autoLabel[0].autoLabel)
    //             );
    //             if (assetMetadata) {
    //                 await this.onAssetMetadataChanged(assetMetadata);
    //             }
    //         }
            
    //     } catch (err) {
    //         console.log(err);
    //         // this.setState({
    //         //     isError: true,
    //         //     errorTitle: err.title,
    //         //     errorMessage: err.message,
    //         // });
    //     } finally {
    //         // catch(error){
    //         //     this.setState({
    //         //         isError: true,
    //         //         errorTitle: error.title,
    //         //         errorMessage: error.message,
    //         //     });
    //         // }
    //         //this.setAutoLabelingStatus(AutoLabelingStatus.done);
    //     }
    // };
}
